"use client";

import React, { useState, useEffect, useCallback } from "react";
import { Table, Container, Spinner, Alert, Button } from "react-bootstrap";
import CreateLandingCardModal from "./modal"; // Adjust the import path as needed
import ActionButton from "../../components/common/ActionBtn";
import editIcon from "../../assets/images/icons/edit-sm-blue.png";
import CustomPagination from "../../components/common/CustomPagination";

import { PERPAGE_RECORD, showToast } from "../../utils/isValidImage";
import {
  StatusChangeNotificationById,
  TrigerNotificationById,
  deleteNotificationById,
  getNotification,
} from "../../api/notification";

const NotificationList = () => {
  const [cards, setCards] = useState([]);
  const [cardDetail, setCardDetail] = useState({});
  const [cardId, setCardId] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Notification?")) {
      try {
        const { data: response } = await deleteNotificationById(id);
        if (response.message) {
          showToast("Notification deleted successfully!", true);
          await fetchCards(pagination.currentPage);
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        showToast("Failed to delete Notification.");
        console.error("Error deleting Notification:", error);
      }
    }
  };

  const handleCopy = async (id) => {
    try {
      const { data: response } = await StatusChangeNotificationById(id);
      if (response.message) {
        showToast("Notification copy successfully!", true);
        await fetchCards(pagination.currentPage);
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      showToast("Failed to copy Notification.");
      console.error("Error copy Notification:", error);
    }
  };

  const handleTriger = async (id) => {
    try {
      const { data: response } = await TrigerNotificationById(id);
      if (response.message) {
        showToast("Notification Trigger successfully!", true);
        await fetchCards(pagination.currentPage);
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      showToast("Failed to Trigger Notification.");
      console.error("Error Trigger Notification:", error);
    }
  };



  const fetchCards = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      // Optionally, you can pass a "type" parameter if needed, e.g., '?type=beast_mode'
      const { data } = await getNotification({ page, limit: PERPAGE_RECORD });
      setCards(data.data);

      const test = {
        "currentPage": data?.pagination?.page,
        "limit": data?.pagination?.limit,
        "totalRecords": data?.pagination?.count || 0,
        "totalPages": Math.ceil(data?.pagination?.count/data?.pagination?.limit)
      }
      setPagination(test);
    } catch (err) {
      console.error("Error fetching Notifications:", err);
      setError("Failed to fetch Notifications. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, []);
  const handleEditClick = async (lCardId) => {
    handleModalShow();
    setCardDetail(lCardId);
    setCardId(lCardId?.id);
  };

  useEffect(() => {
    fetchCards().then();
  }, [fetchCards]);

  const handlePageChange = (page) => {
    fetchCards(page).then();
  };

  const handleModalClose = () => {setCardId(null);setCardDetail({});  setShowModal(false);}
  const handleModalShow = () => { setShowModal(true); }

  const fetchNotificationData = () => {
    // Option 1: Re-fetch the entire list to get updated data and pagination
    fetchCards().then();
    // Option 2: Alternatively, update state locally:
    // setCards(prev => [newCard, ...prev]);
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger" style={{ marginLeft: "160px" }}>
          {error}
          <div className="mt-3">
            <Button onClick={() => fetchCards()}>Retry</Button>
          </div>
        </Alert>
      </Container>
    );
  }

  // console.log("cards", cards);
  return (
    <div className="right-side-wrapper">
      <Container className="mt-4">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <h1 className="mb-4">Notifications</h1>
          <Button variant="success" onClick={handleModalShow} className="mb-4">
            Add Notification
          </Button>
        </div>
        <Table striped bordered hover responsive>
          <thead>
          <tr>
            <th>Id</th>
            <th>Title</th>
            <th>Date & time</th>
            <th>Category</th>
            {/* <th>Status</th> */}
            <th>Edit</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          {cards.map((card) => (
            <tr key={card.id}>
              <td>{card.id}</td>
              <td>{card.title}</td>
              <td>{new Date(card.created_at).toLocaleDateString()}</td>
              <td>{card.content}</td>
              {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      className={`px-2  rounded-lg text-sm ${
                        card.is_active ? "active-btn" : "inactive-btn"
                      }`}
                      style={{ minWidth: "60px", textAlign: "center" }}
                    >
                      {card.is_active ? "Active" : "Inactive"}
                    </span>

                    <Switch
                      onChange={() => toggleStatus(card)}
                      checked={card.is_active}
                      offColor="#ccc"
                      onColor="#4CAF50"
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={20}
                      width={40}
                    />
                  </div>
                </td> */}
              <td>
                <ActionButton
                  icon={editIcon}
                  onClick={() => handleEditClick(card)}
                  altText="Edit"
                  className="additional-class"
                />
              </td>
              <td>
                <button
                  className="btn btn-outline-danger btn-sm me-2"
                  onClick={() => handleDelete(card.id)}
                >
                  Delete
                </button>
                <button
                  className="btn btn-outline-success btn-sm me-2"
                  onClick={() => handleCopy(card.id)}
                >
                  Clone
                </button>
                <button
                  className="btn btn-outline-success btn-sm"
                  onClick={() => handleTriger(card.id)}
                >
                  Triger
                </button>
              </td>
            </tr>
          ))}
          </tbody>
        </Table>
        <CustomPagination pagination={pagination}  handlePageChange={handlePageChange} />
      </Container>
      <CreateLandingCardModal
        show={showModal}
        handleClose={handleModalClose}
        fetchdata={fetchNotificationData}
        cardDetail={cardDetail}
        cardId={cardId}
      />
    </div>
  );
};

export default NotificationList;
